import providerModuleMutations from "./providerModule/mutations";

export default {
  ...providerModuleMutations,
};
